import React, { useState } from "react";

/**
 * UserAvatar — renders a user's profile picture if available, otherwise
 * falls back to a circle with their initials. Used wherever a user's name
 * is shown alongside an avatar (agent cards, sidebar, property pages).
 */
const UserAvatar = ({
  src,
  name = "",
  size = 40,
  bgColor = "#575955",
  textColor = "#ffffff",
  className = "",
  alt,
  rounded = true,
}) => {
  const [imgFailed, setImgFailed] = useState(false);

  const initials = (name || "")
    .toString()
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase() || "U";

  const dimensionStyle = {
    width: size,
    height: size,
    minWidth: size,
    minHeight: size,
  };

  const showImage = src && !imgFailed;
  const radiusClass = rounded ? "rounded-full" : "rounded-lg";

  if (showImage) {
    return (
      <img
        src={src}
        alt={alt || name || "User avatar"}
        onError={() => setImgFailed(true)}
        style={dimensionStyle}
        className={`${radiusClass} object-cover shadow-sm shrink-0 ${className}`}
      />
    );
  }

  return (
    <div
      style={{ ...dimensionStyle, backgroundColor: bgColor, color: textColor, fontSize: Math.max(12, size * 0.4) }}
      className={`${radiusClass} flex items-center justify-center font-semibold shadow-sm shrink-0 ${className}`}
      aria-label={alt || name || "User avatar"}
    >
      {initials}
    </div>
  );
};

export default UserAvatar;
